<div class="vo-loader loader" *ngIf="showLoading">
  <div class="overlay">
    <div class="message-container d-flex flex-column align-items-center p-10">
      <div class="message-header vo-body-bold-16 my-10 word-break" [innerHtml]="progressBarHeaderText"></div>
      <div class="message-body vo-body-regular-12 mb-10 word-break" [innerHtml]="progressBarBodyText"></div>
    </div>
  </div>
</div>